import { nFormatter } from "utils/parseNumber";

import { ReactComponent as ProfileIcon } from "components/icons/profileIcon.svg";

import "./SubscriberCount.scss";

export const SubscriberCount = (props: {
  count: number;
}): JSX.Element => {
  return (
    <div className="subscribers">
      <ProfileIcon />
      <span>{nFormatter(props.count)}</span>
    </div>
  );
};
